import firebase from "../firebase";
import { SURVEY_LIST, SHOW_TOAST, REFRESH_CARD, FB_URL } from "./types";
import { _toArray } from "./commonActions";
import axios from 'axios';

const {v4: uuidv4} = require('uuid')

export const createSurvey = params => {
  console.log('createSurvey test 1');

  if (params.type === SURVEY_LIST) {
  return async (dispatch, getState) => {

    var valueID = params.thoughtID; //uuidv4();
    var timeInMs = Date.now();

    var data = {
      surveyid: params.thoughtID, //valueID,
      title: params.title,
      companyID: params.companyID,
      //real_companyID: params.companyID,
      type: params.typeofSurvey,
      size: params.size,
      // Include all QandA fields dynamically (only if they exist and are not undefined)
      ...(params.QandA1 && { QandA1: params.QandA1 }),
      ...(params.QandA2 && { QandA2: params.QandA2 }),
      ...(params.QandA3 && { QandA3: params.QandA3 }),
      ...(params.QandA4 && { QandA4: params.QandA4 }),
      ...(params.QandA5 && { QandA5: params.QandA5 }),
      ...(params.QandA6 && { QandA6: params.QandA6 }),
      ...(params.QandA7 && { QandA7: params.QandA7 }),
      ...(params.QandA8 && { QandA8: params.QandA8 }),
      ...(params.QandA9 && { QandA9: params.QandA9 }),
      ...(params.QandA10 && { QandA10: params.QandA10 }),
      ...(params.QandA11 && { QandA11: params.QandA11 }),
      ...(params.QandA12 && { QandA12: params.QandA12 }),
      ...(params.QandA13 && { QandA13: params.QandA13 }),
      ...(params.QandA14 && { QandA14: params.QandA14 }),
      ...(params.QandA15 && { QandA15: params.QandA15 }),
      ...(params.QandA16 && { QandA16: params.QandA16 }),
      ...(params.QandA17 && { QandA17: params.QandA17 }),
      ...(params.QandA18 && { QandA18: params.QandA18 }),
      ...(params.QandA19 && { QandA19: params.QandA19 }),
      ...(params.QandA20 && { QandA20: params.QandA20 }),
      // Enhanced test features
      sections: params.sections || [],
      testComplexity: params.testComplexity || 'basic',
      categoryType: params.categoryType || 'general',
      estimatedLCReward: params.estimatedLCReward || 0.07,
      // Track source of test generation to handle post edits correctly
      testSource: params.testSource || 'content',
      sourceMeta: params.sourceMeta || {},
      ownMaterial: params.ownMaterial,
      dailyThoughtType: params.dailyThoughtType,
      groupid: params.groupid
    };
    
    // Add any additional QandA fields that might exist, ensuring no undefined values
    Object.keys(params).forEach(key => {
      if (key.startsWith('QandA') && !data.hasOwnProperty(key) && params[key] !== undefined) {
        // Clean the question data to remove any undefined values
        const questionData = params[key];
        if (questionData && typeof questionData === 'object') {
          data[key] = {
            question: questionData.question || '',
            a1: questionData.a1 || '',
            a2: questionData.a2 || '',
            a3: questionData.a3 || '',
            a4: questionData.a4 || '',
            a5: questionData.a5 || '',
            sectionId: questionData.sectionId || 'default',
            sectionName: questionData.sectionName || 'Section'
          };
        }
      }
    });
    // Write the new rating data

    var updates = {};
    updates[`surveys/${params.companyID}/` + valueID] = data;
    if (params.dailyThoughtType==='4' || params.dailyThoughtType===4)
    {
      updates[`company-group-posts/${params.companyID}/${params.thoughtID}/stage`] = 2; //test published
      updates[`group-posts/${params.groupid}/${params.thoughtID}/stage`] = 2; //test published
    }
    else {
      updates[`dailyThoughts/${params.thoughtID}/stage`] = 2; //test published
    }
      console.log('createSurvey test 2');

        var res = await axios.post(`${FB_URL}/m115-freshcard`, {
            params: {
                updates: updates, //user wallet address                       
            }
          })

      if (res.data || res.data.success === true) {
         dispatch({
           type: SURVEY_LIST,
           message: "Survey posted successfully!",
           variant: "success"
         });
      }
      else {
         dispatch({
           type: SHOW_TOAST,
           message: err.message,
           variant: "error.."
         });
      };

    // firebase.database
    //   .ref()
    //   .update(updates)
    //   .then(() => {

    //     // dispatch({
    //     //   type: SHOW_TOAST,
    //     //   message: "Survey posted successfully!",
    //     //   variant: "success"
    //     // });

    //     dispatch({
    //       type: SURVEY_LIST,
    //       message: "Survey posted successfully!",
    //       variant: "success"
    //     });
    //   })
    //   .catch(err => {
    //     dispatch({
    //       type: SHOW_TOAST,
    //       message: err.message,
    //       variant: "error.."
    //     });
    //   });
  };
 }
};

export const refreshCard = params => {
  

  if (params.type === REFRESH_CARD) {
    return (dispatch, getState) => {
        if (params.refresh===true) {      
          dispatch({
            type: REFRESH_CARD,
            survey_refresh: 'show'
          });
    
        } else {
          return (dispatch, getState) => {
            dispatch({
              type: REFRESH_CARD,
              survey_refresh: 'noshow'
            });
          };
        }
   } 
 }
};
